import React, { Component } from 'react';
import { Checkbox, Select, message, Modal, Button, Popconfirm, Icon, Alert } from 'antd';
import CelaneseAPI from '../../services';
import './ShareFilterCigarette.css';
import ShareWithEmail from '../../components/ShareWithEmail';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Translation from '../../Translation';
import { utils } from '../../config';

const Option = Select.Option;

/**
 * Class for sharing filter and cigarette.
 *
 * @class ShareFilterCigarette
 * @extends {React.Component}
 */
class ShareFilterCigarette extends Component {

    constructor(props) {
        super(props);

        this.columns = [{
            title: 'Category',
            dataIndex: 'category',
            key: 'category',
        }, {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
        }, {
            title: 'Shared To',
            dataIndex: 'sharedto',
            key: 'sharedto',
        }, {
            title: 'Action',
            key: 'action',
            render: (rec) => (
                <Popconfirm title={<Translation labelName="msg_are_u_sure_want_delete" defaultText="Are you sure, do you want delete?" />} placement="topRight" icon={<Icon type="question-circle-o" style={{ color: 'red' }} />} onConfirm={(e) => this.deleteShareEntity(e, rec)} onCancel={this.cancelAction} okText={<Translation labelName="lbl_yes" defaultText="Yes" />} cancelText={<Translation labelName="lbl_no" defaultText="No" />}>
                    <a className="table-links"><Translation labelName="btn_delete" defaultText="Delete"/></a>
                </Popconfirm>
            ),
        }
        ];
        this.state = {
            rows: [],
            dataSource: [],
            apiDataForFilter: [],
            apiDataForCigarette: [],
            apiDataForCarbonFilter: [],
            apiDataForCarbonCigarette: [],
            checkedfilter: false,
            checkedcigarette: false,
            checkedCarbonCigarette: false,
            checkedFilterCarbon: false,
            isShareWithEmailVisible: false,
            selectedFilter: {},
            selectedCigarette: {},
            selectedCarbonFilter: {},
            selectedCarbonCigarette: {},
            sharedData: {},
            loading: false,
            loadingTable: false
        };

        this.showShareWithEmail = this.showShareWithEmail.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        this.assignData(nextProps);
    }
    componentWillMount() {
        this.getData();
        this.assignData(this.props);
    }

    /**
     * getData function is for getting all the existing single and dual filters and cigarettes and populating them into the dropdowns
     * 
     * @memberof ShareFilterCigarette
     */
    getData = () => {
        this.setState({
            loadingTable: true
        });
        CelaneseAPI.get('/share-entity').then((res) => {
            this.setState({
                sharedData: res.data
            });

            let rowsData = [];
            let data = this.state.sharedData || [];

            for (let i = 0; i < data.length; i++) {
                let sharedTo = data[i].sharedTo;
                let category = '';

                if (data[i].shareType === 'CIGARETTE_BRAND') {
                    category = 'Mono Acetate Cigarette';
                }
                else if (data[i].shareType === 'FILTER_BRAND') {
                    category = 'Mono Acetate Filter';
                }
                else if (data[i].shareType === 'CARB_FILTER_BRAND') {
                    category = 'Carbon Dual Filter';
                }
                else if (data[i].shareType === 'CARB_CIGARETTE_BRAND') {
                    category = 'Carbon Dual Cigarette';
                }

                rowsData.push({
                    'category': category,
                    'name': data[i].shareType === 'CARB_FILTER_BRAND' ? data[i].sharedData.dualFilterName : data[i].sharedData.name,
                    'sharedto': sharedTo,
                    'id': data[i].id,
                    'key': data[i].id
                });
            }
            this.setState({ dataSource: rowsData, loadingTable: false });
        });
    }

    /**
     * assignData function is for getting the filter/cigarette data from redux/store
     * @param {object|array} nextProps
     * @memberof ShareFilterCigarette
     */
    assignData = (nextProps) => {
        if (nextProps.filtersData) {
            this.setState({
                apiDataForFilter: nextProps.filtersData
            })
        }
        if (nextProps.carbonFiltersData) {
            this.setState({
                apiDataForCarbonFilter: nextProps.carbonFiltersData
            })
        }
        if (nextProps.cigaretteData) {
            this.setState({
                apiDataForCigarette: nextProps.cigaretteData
            })
        }
        if (nextProps.carbonCigaretteData) {
            this.setState({
                apiDataForCarbonCigarette: nextProps.carbonCigaretteData
            })
        }
    }

    /**
     * success function shows a success message when shared filter/cigarette is deleted successfully
     * 
     * @memberof ShareFilterCigarette
     */
    success = () => {
        message.success(utils.getTranslationText('msg_data_sucess_deleted', 'Data successfully deleted.'), 1);
    }
    cancelAction = () => {

    }

    /**
     * deleteShareEntity function deletes the shared filter/cigarette.
     * 
     * @param {*} e here e is an event passed
     * @param {object} rec here rec is the shared filter/cigarette that is to be deleted
     * @memberof ShareFilterCigarette
     */
    deleteShareEntity = (e, rec) => {
        e.preventDefault();
        if (rec) {
            this.setState({
                loadingTable: true
            });
            CelaneseAPI.delete('/share-entity/' + rec.id).then((res) => {
                if (res) {
                    this.success();
                    this.getData();
                }
            });
        }
    }

    /**
     * error function shows an error message if no filter/cigarette is selected
     * 
     * @memberof ShareFilterCigarette
     */
    error = () => {
        message.error( utils.getTranslationText('msg_plz_select_one_value_share','Please Select atleast One value to Share.'), 1);
    };

    /**
     * handleCancel function closes the share email window
     * 
     * @memberof ShareFilterCigarette
     */
    handleCancel() {
        this.props.showShareScreen(false);
    }

    /**
     * handleFilterChange function takes the value of the selected filter
     * @param {string} value here value is selected filter
     * @memberof ShareFilterCigarette
     */
    handleFilterChange = (value) => {
        let data = this.state.apiDataForFilter
        let result = data.find(element => element.name === value);

        this.setState({
            selectedFilter: result
        });
    }

    /**
     * handleCarbonFilterChange function takes the value of the selected carbon filter
     * @param {string} value here value is selected carbon filter
     * @memberof ShareFilterCigarette
     */
    handleCarbonFilterChange = (value) => {
        let data = this.state.apiDataForCarbonFilter
        let result = data.find(element => element.dualFilterName === value);
        this.setState({
            selectedCarbonFilter: result
        });
    }

    /**
     * handleCigaretteChange function takes the value of the selected cigarette
     * @param {string} value here value is selected cigarette
     * @memberof ShareFilterCigarette
     */
    handleCigaretteChange = (value) => {
        let data = this.state.apiDataForCigarette
        let result = data.find(element => element.name === value);

        this.setState({
            selectedCigarette: result
        });
    }

    /**
     * handleCarbonCigaretteChange function takes the value of the selected carbon cigarette
     * @param {string} value here value is selected carbon cigarette
     * @memberof ShareFilterCigarette
     */
    handleCarbonCigaretteChange = (value) => {
        let data = this.state.apiDataForCarbonCigarette
        let result = data.find(element => element.name === value);

        this.setState({
            selectedCarbonCigarette: result
        });
    }

    /**
     * handleFilterCheck function toggles the checkbox for filter
     * 
     * @memberof ShareFilterCigarette
     */
    handleFilterCheck = () => {
        this.setState({
            checkedfilter: !this.state.checkedfilter
        });
    }

    /**
     * handleCigaretteCheck function toggles the checkbox for cigarette
     * 
     * @memberof ShareFilterCigarette
     */
    handleCigaretteCheck = () => {
        this.setState({
            checkedcigarette: !this.state.checkedcigarette
        });
    }

    /**
     * handleCarbonCigaretteCheck function toggles the checkbox for carbon cigarette
     * 
     * @memberof ShareFilterCigarette
     */
    handleCarbonCigaretteCheck = () => {
        this.setState({
            checkedCarbonCigarette: !this.state.checkedCarbonCigarette
        });
    }

    /**
     * handleCarbonFilterCheck function toggles the checkbox for carbon filter
     * 
     * @memberof ShareFilterCigarette
     */
    handleCarbonFilterCheck = () => {
        this.setState({
            checkedFilterCarbon: !this.state.checkedFilterCarbon
        });
    }

    /**
    * objIsEmpty checks if object is empty
    * @param {object} obj
    * @memberof ShareFilterCigarette
    */
    objIsEmpty = (obj) => {
        for (var key in obj) {
            if (obj.hasOwnProperty(key))
                return false;
        }
        return true;
    }

    /**
     * showShareWithEmail function shows the share email window
     * @param {boolean} isShareWithEmailVisible 
     * @param {*} e here e is an event passed
     * @memberof ShareFilterCigarette
     */
    showShareWithEmail(isShareWithEmailVisible, e) {
        if (e) {
            e.preventDefault();
        }
        if (isShareWithEmailVisible) {
            let _this = this;
            let content = '';
            content += this.state.selectedCigarette && this.state.selectedCigarette.name ? this.state.selectedCigarette.name + ', ' : '';
            content += this.state.selectedFilter && this.state.selectedFilter.name ? this.state.selectedFilter.name + ', ' : '';
            content += this.state.selectedCarbonCigarette && this.state.selectedCarbonCigarette.name ? this.state.selectedCarbonCigarette.name + ', ' : '';
            content += this.state.selectedCarbonFilter && this.state.selectedCarbonFilter.dualFilterName ? this.state.selectedCarbonFilter.dualFilterName + ', ' : '';
            if (content) {
                Modal.confirm({
                    title: utils.getTranslationText('msg_are_u_sure_want_to_share_items','Are you sure you want to share these items?'),
                    content: content.replace(/, +$/, ''),
                    okText: utils.getTranslationText('lbl_yes','Yes'),
                    okType: 'info',
                    cancelText: utils.getTranslationText('lbl_no','No'),
                    onOk() {
                        if (_this.objIsEmpty(_this.state.selectedCigarette) && _this.objIsEmpty(_this.state.selectedFilter) && _this.objIsEmpty(_this.state.selectedCarbonFilter) && _this.objIsEmpty(_this.state.selectedCarbonCigarette)) {
                            _this.error();
                        }
                        else {
                            _this.setState({ isShareWithEmailVisible: isShareWithEmailVisible ? true : false });
                        }
                    },
                    onCancel() {

                    },
                });
            } else {
                _this.error();
            }
        } else {
            this.setState({ isShareWithEmailVisible: false });
        }
    }


    render() {
        const childrenFilter = [];
        const dataFilter = this.state.apiDataForFilter ? this.state.apiDataForFilter : [];
        for (let i = 0; i < dataFilter.length; i++) {
            if (!dataFilter[i].isShared) {
                childrenFilter.push(<Option key={i} value={dataFilter[i].name}>{dataFilter[i].name}</Option>);
            }
        }
        const childrenCigarette = [];
        const dataCigarette = this.state.apiDataForCigarette ? this.state.apiDataForCigarette : [];
        for (let i = 0; i < dataCigarette.length; i++) {
            if (!dataCigarette[i].isShared) {
                childrenCigarette.push(<Option key={i} value={dataCigarette[i].name}>{dataCigarette[i].name}</Option>);
            }
        }

        const childrenCarbonFilter = [];
        const dataCarbonFilter = this.state.apiDataForCarbonFilter ? this.state.apiDataForCarbonFilter : [];
        for (let i = 0; i < dataCarbonFilter.length; i++) {
            if (!dataCarbonFilter[i].isShared) {
                childrenCarbonFilter.push(<Option key={i} value={dataCarbonFilter[i].dualFilterName}>{dataCarbonFilter[i].dualFilterName}</Option>);
            }
        }
        const childrenCarbonCigarette = [];
        const dataCarbonCigarette = this.state.apiDataForCarbonCigarette ? this.state.apiDataForCarbonCigarette : [];
        for (let i = 0; i < dataCarbonCigarette.length; i++) {
            if (!dataCarbonCigarette[i].isShared) {
                childrenCarbonCigarette.push(<Option key={i} value={dataCarbonCigarette[i].name}>{dataCarbonCigarette[i].name}</Option>);
            }
        }


        let propsToSend = {};

        if (this.state.checkedfilter)
            propsToSend['selectedFilter'] = this.state.selectedFilter || {};

        if (this.state.checkedFilterCarbon)
            propsToSend['selectedCarbonFilter'] = this.state.selectedCarbonFilter || {};


        if (this.state.checkedCarbonCigarette)
            propsToSend['selectedCarbonCigarette'] = this.state.selectedCarbonCigarette || {};


        if (this.state.checkedcigarette)
            propsToSend['selectedCigarette'] = this.state.selectedCigarette || {};

        return (
            <div>
                <Modal title={<Translation labelName="lbl_share_filter_cigarette" defaultText="Share Filter/Cigarette" />}
                    visible={this.props.isShareVisible}
                    footer={null}
                    centered
                    onCancel={() => this.handleCancel()}
                    width="50%">
                    <div className="share">
                        {/* <a href='/help/html/Share_Filter_Cigarette_Designs.htm' title="Help" target="_blank" className="help-section">
                            <img
                                src="./images/help-inverse-black.svg"
                                alt="help"
                                className="help-icon" />
                        </a> */}
                        <Alert
                            className="m2-bottom"
                            description={<Translation labelName="msg_share_filter_warning" defaultText="When you share an item, all the associated tow items, plugwraps, filters and combined filters will be also shared." />}
                            type="warning"
                            showIcon
                        />
                        <div className="filter row">
                            <div className="dropdown-wrapper share__filter col-md-12">
                                <Checkbox
                                    onChange={this.handleFilterCheck}
                                    className="filter-title col-md-3"><Translation labelName="lbl_filter_design" defaultText="Filter Designs" /></Checkbox>
                                <Select
                                    className="col-md-9 text-left"
                                    onSelect={this.handleFilterChange}
                                    placeholder={<Translation labelName="lbl_please_select" defaultText="Please Select" />}
                                    disabled={!this.state.checkedfilter}>
                                    {childrenFilter}
                                </Select>
                            </div>
                            <div className="dropdown-wrapper share__carbon-filter col-md-12">
                                <Checkbox
                                    className="col-md-3 carbon-filter__checkbox"
                                    checked={this.state.checkedFilterCarbon}
                                    onChange={this.handleCarbonFilterCheck}><Translation labelName="lbl_dual_filter_design" defaultText="Dual Filter Designs" /></Checkbox>
                                <Select
                                    className="col-md-9 text-left carbon-filter__select"
                                    onSelect={this.handleCarbonFilterChange}
                                    disabled={!this.state.checkedFilterCarbon}
                                    placeholder={<Translation labelName="lbl_please_select" defaultText="Please Select" />}>
                                    {childrenCarbonFilter}
                                </Select>
                            </div>
                        </div>
                        <div className="cigarette row">
                            <div className="dropdown-wrapper share__cigarette col-md-12">
                                <Checkbox
                                    className="col-md-3"
                                    checked={this.state.checkedcigarette}
                                    onChange={this.handleCigaretteCheck}><Translation labelName="lbl_cigarette_design" defaultText="Cigarette Designs" /></Checkbox>
                                <Select
                                    className="col-md-9 text-left"
                                    onSelect={this.handleCigaretteChange}
                                    disabled={!this.state.checkedcigarette}
                                    placeholder={<Translation labelName="lbl_please_select" defaultText="Please Select" />}>
                                    {childrenCigarette}
                                </Select>
                            </div>
                            <div className="dropdown-wrapper no-border share__carbon-cigarette col-md-12">
                                <Checkbox
                                    className="col-md-3 carbon-cigarette__checkbox"
                                    checked={this.state.checkedCarbonCigarette}
                                    onChange={this.handleCarbonCigaretteCheck}><Translation labelName="lbl_dual_cigarette" defaultText="Dual Cigarette Designs" /></Checkbox>
                                <Select
                                    className="col-md-9 text-left carbon-cigarette__select"
                                    onSelect={this.handleCarbonCigaretteChange}
                                    disabled={!this.state.checkedCarbonCigarette}
                                    placeholder={<Translation labelName="lbl_please_select" defaultText="Please Select" />}>
                                    {childrenCarbonCigarette}
                                </Select>
                            </div>
                        </div>

                        {/* {this.state.dataSource.length ? 
                        <Table
                            dataSource={this.state.dataSource}
                            columns={this.columns}
                            bordered
                            size="small"
                            pagination={false}
                            className="table-share-data"
                            loading={this.state.loadingTable}
                        />
                        : null } */}
                        <div className="btn-wrapper">
                            <Button type="primary" className="btn btn-primary share-btn" loading={this.state.loading} onClick={(e) => this.showShareWithEmail(true, e)}>
                                <Translation labelName="btn_share" defaultText="SHARE" />
                            </Button>
                        </div>
                        {this.state.isShareWithEmailVisible && <ShareWithEmail
                            isShareWithEmailVisible={this.state.isShareWithEmailVisible}
                            showShareWithEmail={this.showShareWithEmail}
                            getData={this.getData}
                            {...this.state}
                            {...propsToSend} >
                        </ShareWithEmail>
                        }
                    </div>
                </Modal>
            </div>
        );
    }
}

const mapStateToProps = ({ filtersState }) => ({
    filtersData: filtersState.filtersData,
    carbonFiltersData: filtersState.carbonFiltersData,
    cigaretteData: filtersState.cigaretteData,
    carbonCigaretteData: filtersState.carbonCigaretteData
});

export default connect(mapStateToProps, null)(ShareFilterCigarette);

ShareFilterCigarette.propTypes = {
    showShareScreen: PropTypes.func,
    isShareVisible: PropTypes.bool,
    filtersData: PropTypes.array,
    carbonFiltersData: PropTypes.array,
    cigaretteData: PropTypes.any,
    carbonCigaretteData: PropTypes.any
}


// WEBPACK FOOTER //
// ./src/containers/ShareFilterCigarette/index.js